import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetMarkAnimationSettingParams {
  user: string;
}

export interface IGetMarkAnimationSettingResult extends IResult {
  enabled: boolean;
}
export class GetMarkAnimationSettingRequest extends Request<IGetMarkAnimationSettingParams, IResult> {
  constructor(params: IGetMarkAnimationSettingParams) {
    super('getMarkAnimationEnabledSetting', params);
  }
}
